export default "__VITE_ASSET__OVffcXWI__"